import { render } from "./delivery-staff-add-or-edit.vue?vue&type=template&id=3d58c627&scoped=true&ts=true"
import script from "./delivery-staff-add-or-edit.vue?vue&type=script&lang=ts"
export * from "./delivery-staff-add-or-edit.vue?vue&type=script&lang=ts"

import "./delivery-staff-add-or-edit.vue?vue&type=style&index=0&id=3d58c627&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d58c627"]])

export default __exports__